import { FavWorkout } from '../dao/core-dao'
import { coreService } from '../service/core-service'
import { UseMutationResult, UseQueryOptions, UseQueryResult, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from 'src/util/query-keys'
import { toasterUtil } from 'src/util/toaster-util'

export const useFavoriteWorkouts = (
  options?: Omit<UseQueryOptions<FavWorkout[], Error>, 'queryKey' | 'queryFn'>,
): UseQueryResult<FavWorkout[], Error> => {
  return useQuery<FavWorkout[], Error>(queryKeys.favoriteWorkouts(), () => coreService.getFavoriteWorkouts(), {
    ...options,
  })
}

export const useAddToFavorites = (): UseMutationResult<FavWorkout, Error, { workoutId: string }> => {
  const queryClient = useQueryClient()

  return useMutation<FavWorkout, Error, { workoutId: string }>(({ workoutId }) => coreService.addToFavorites({ workoutId }), {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.favoriteWorkouts())
      toasterUtil.success('Workout added to favorites')
    },
    onError: () => {
      toasterUtil.error('Failed to add workout to favorites, please try again.')
    },
  })
}

export const useRemoveFavoriteWorkout = (): UseMutationResult<void, Error, { id: string }> => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, { id: string }>(({ id }) => coreService.removeFavoriteWorkout({ id }), {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.favoriteWorkouts())
      toasterUtil.success('Workout removed from favorites')
    },
    onError: () => {
      toasterUtil.error('Failed to remove workout from favorites, please try again.')
    },
  })
}
